import { map, Observable } from 'rxjs';
import { CompanyModel, ScreenUser } from '../models/iam-dtos';
import { GetUserPermissionsTransforms } from './get-user-permissions.transform';
import { IamWrapperConstants } from '../iamWrapperConstants';
import { TransformUtilities } from './utilities.transform';
import { UserResponseModel } from '../services/iamapi/iamapi.services';

export class GetUserAccessedCompaniesAndScreenPermissionsTransform {
  static transformOutput(
    observableResponse: Observable<UserResponseModel>): Observable<{
      screenPermissions: ScreenUser;
      companyData: CompanyModel[];
    }> {
    const base10 = 10;
    return observableResponse.pipe(
      map((usersDto: UserResponseModel) => ({
            screenPermissions: GetUserAccessedCompaniesAndScreenPermissionsTransform.generateScreenPermissions(usersDto, base10),
            companyData: TransformUtilities.ExtractUserAccessedCompanies(usersDto),
        })),
    );
  }

  static generateScreenPermissions(usersDto: UserResponseModel, base10: number): ScreenUser {
    const screenUser = new ScreenUser({
        userId: parseInt(usersDto.personId, base10),
        userName: [usersDto.firstName, usersDto.middleName, usersDto.lastName].join(' '),
        objectId: usersDto.objectId,
        roles: GetUserPermissionsTransforms.mapPermissionsToScreenRoles(usersDto.roles, usersDto.resources),
      });
      screenUser[IamWrapperConstants.UserCompaniesKey] = usersDto.companies;
      return screenUser;
  }
}
